import state from './moduleCrossCheckingManagementState';
import mutations from './moduleCrossCheckingManagementMutations';
import actions from './moduleCrossCheckingManagementActions';
import getters from './moduleCrossCheckingManagementGetters';

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
